<template>
    <div>
        <div>
        <h3>{{ project.name }}</h3>
        </div>
        <div v-if="tier === null" style="color: #4d535e; font-size: 14px">Loading Project Tier...</div>
        <div v-else-if="tier === 0" style="font-size: 17px;">
            <span style="font-weight: 500; color: #ba3951">Project Tier: Free</span>, only premium users can join 
            <b-btn v-if="!(project.upgradedOverride)" style="margin-left: 5px; margin-bottom: 7px; height: 26px; line-height: 14px; padding-left: 12px; padding-right: 12px" v-b-tooltip="'Projects must be upgraded to allow non-premium users to join'" variant="outline-dark" size="sm" @click="$refs.upgradeProjectModal.show()" pill><i class="fas fa-file-invoice-dollar"/> Upgrade Project</b-btn>
        </div>
        <div v-else style="font-size: 17px">
            <span style="font-weight: 500; color: #247a59">Project Tier: {{tier}}</span>, Non-premium members: {{ freeUserCount }} out of {{ freeUserBudget_local }} allowed 
            <span v-if="!(project.upgradedOverride)">
                <b-btn v-if="tier < 4" style="margin-left: 5px; margin-bottom: 7px; height: 26px; line-height: 14px; padding-left: 12px; padding-right: 12px" variant="cliovis-blue-light" size="sm" @click="$refs.upgradeProjectModal.show()" pill><i class="fas fa-plus"/> Increase Limit</b-btn>
                <b-btn v-else style="margin-left: 5px; margin-bottom: 7px; height: 26px; line-height: 14px; padding-left: 12px; padding-right: 12px" variant="outline-dark" size="sm" @click="$refs.upgradeProjectModal.show()" pill><i class="fas fa-file-invoice-dollar"/> Manage Upgrade</b-btn>
            </span>
        </div>
        <!--
            <p><i>Note: Role permissions editing is not currently supported.  This feature is coming soon.  For now, simply edit in the <a href="https://cliovis.com/webapp">ClioVis webapp</a>.</i></p>
        -->
        <div class="userdata-container">
            <b-container>
                <b-row>
                    <b-col>
                        <h4>Members of {{ project.name }} <span style="font-size: 13px; font-weight: 400; color: #343B3F">(Total members: {{(users ? users.length : '...')}})</span></h4>
                        <b-input-group class="mb-3">
                            <b-input-group-prepend><b-input-group-text><i class="fas fa-search" /></b-input-group-text></b-input-group-prepend>
                            <b-form-input
                                v-model="user_filter"
                                type="text"
                                class="form-control"
                                placeholder="Search members"
                            />
                        </b-input-group>
                        <div class="user_box">
                            <div v-if="users">
                                <div
                                    v-for="(usr) in filteredUsers"
                                    :key="usr.userid"
                                    class="user_entry"
                                >
                                    <b-container>
                                        <b-row>
                                            <b-col cols="6">
                                                <best-fit-text role="heading" aria-level="4" :max="23">{{ usr.uiName }}</best-fit-text><br>
                                                <best-fit-text :max="16" style="margin: 0; padding: 0;">
                                                    {{ usr.email }}
                                                </best-fit-text>
                                                <div style="margin: 0; padding: 0; font-size: 80%;">
                                                    <span v-if="usr.premium" style="color: #247a59;"><i class="fas fa-certificate" style="margin-right: 0; color: #247a59;"></i> Premium User</span>
                                                    <span v-else style="color: #4d535e">Non-premium User</span>
                                                </div>
                                            </b-col>
                                            <b-col cols="4" style="margin-top: 24px">
                                                <b-form-select
                                                    v-if="usergroups"
                                                    v-model="usr.userGroupID"
                                                    :disabled="(usr.userid.toLowerCase() == user.userid.toLowerCase()) || !checkUserManage(project.group, usergroupFromID(usr.userGroupID))"
                                                    @change="(value)=>{changeUserGroup(usr, usr.userGroupID, value)}"
                                                >
                                                    <option
                                                        v-for="(group, id) in usergroups"
                                                        :disabled="!checkUserManage(project.group, group)"
                                                        :key="id"
                                                        :value="group.id"
                                                    >
                                                        {{ group.name }}
                                                    </option>
                                                </b-form-select>
                                            </b-col>
                                            <b-col style="margin-top: 24px">
                                                <b-btn
                                                    :disabled="(usr.userid.toLowerCase() == user.userid.toLowerCase()) || !checkUserManage(project.group, usergroupFromID(usr.userGroupId))"
                                                    style="display: block;margin-left: auto;"
                                                    variant="danger"
                                                    @click="removeUser(usr)"
                                                >
                                                    <i
                                                        class="fas fa-trash"
                                                        style="margin-right: 0"
                                                    />
                                                </b-btn>
                                            </b-col>
                                        </b-row>
                                    </b-container>
                                </div>
                            </div>
                            <div v-else>
                                Loading user data...
                            </div>
                        </div>
                        <br>
                        <b-row>
                            <b-col>
                                <b-btn
                                    v-if="checkUserManage(project.group)"
                                    block
                                    variant="cliovis-blue-light"
                                    @click="clickAddUser"
                                >
                                    <i class="fas fa-plus" /> Add New User
                                </b-btn>
                            </b-col>
                            <b-col>
                                <b-btn
                                    block
                                    variant="cliovis-blue-light"
                                    @click="loadUserData"
                                >
                                    <i class="fas fa-sync" /> Refresh Users
                                </b-btn>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col>
                        <h3>Roles</h3>
                        <div v-if="usergroups">
                            <p>Choose a Role to edit, or create a new one</p>
                            <b-form-group>
                                <b-form-select
                                    v-model="group_editor.active_group"
                                    class="usergroup_select"
                                    @change="onActiveGroupChanged"
                                >
                                    <option :value="null">
                                        Select a Role
                                    </option>
                                    <option
                                        v-for="(group, id) in usergroups"
                                        :key="id"
                                        :value="group"
                                        :disabled="!checkUserManage(project.group, group)"
                                        @change="(value)=>{changeUserGroup(usr, usr.userGroupID, id)}"
                                    >
                                        {{ group.name }}
                                    </option>
                                </b-form-select>
                                <b-btn
                                    v-if="checkUserGroupEdit(project.group, group_editor.active_group)"
                                    :disabled="!(group_editor.active_group) || (group_editor.active_group.id < 2)"
                                    variant="danger"
                                    class="l-margin"
                                    @click="clickDeleteUsergroup"
                                >
                                    Delete Role
                                </b-btn>
                                <b-btn
                                    v-if="checkUserGroupEdit(project.group)"
                                    variant="cliovis-blue-light"
                                    class="l-margin"
                                    style="margin-right: -10px"
                                    @click="clickCreateUsergroup"
                                >
                                    <i class="fas fa-plus-circle" /> Create New
                                </b-btn>
                            </b-form-group>
                            <div v-if="group_editor.active_group">
                                <b-form-group>
                                    <b-form-checkbox-group
                                        v-model="group_editor.selected_perms"
                                        @change="modifyUserGroupPermissions"
                                    >
                                        <div
                                            v-for="(perm, id) in group_editor.permission_data"
                                            :key="id"
                                        >
                                            <b-form-checkbox 
                                                :disabled="(group_editor.active_group.id < 2) || !checkUserGroupEdit(project.group, group_editor.active_group) || !(checkPermissions(perm.perm))" 
                                                :value="perm.perm"
                                            >
                                                {{ perm.name }}
                                            </b-form-checkbox>
                                        </div>
                                    </b-form-checkbox-group>
                                </b-form-group>

                                <!-- :disabled="!dueDateEnabled || group_editor.active_group.id < 2" -->
                                <!-- TODO: Finish due date component
								<b-btn block @click="$refs.dueDateModal.show()" variant="cliovis-blue-light">Due Date</b-btn>
                                -->
                                <b-modal
                                    ref="dueDateModal"
                                    title="Due Date"
                                    centered
                                >
                                    <due-date
                                        :key="generational_key.toString() + '_dd'"
                                        ref="dueDate"
                                        :project="project"
                                        :group_editor="group_editor"
                                        @request-enable="(v)=>{dueDateEnabled=v;}"
                                    />
                                    <template slot="modal-footer">
                                        <b-btn @click="$refs.dueDateModal.hide()">
                                            Cancel
                                        </b-btn>
                                        <div
                                            v-if="$refs.dueDate"
                                            :key="generational_key"
                                        >
                                            <b-btn
                                                v-if="$refs.dueDate.jobs.length > 0"
                                                variant="danger"
                                                @click="$refs.dueDate.deleteDueDate()"
                                            >
                                                Remove Due Date
                                            </b-btn>
                                            <b-btn
                                                variant="cliovis-blue-light"
                                                @click="$refs.dueDate.setDueDate()"
                                            >
                                                <span v-if="$refs.dueDate.jobs.length > 0">
                                                    Update Due Date
                                                </span>
                                                <span v-else>
                                                    Set Due Date
                                                </span>
                                            </b-btn>
                                        </div>
                                    </template>
                                </b-modal>
                            </div>
                        </div>
                        <div v-else>
                            Loading Roles...
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <b-modal
                ref="addUserModal"
                :title="'Add User to ' + project.name"
                :no-close-on-esc="modalData.noClose"
                :no-close-on-backdrop="modalData.noClose"
            >
                <b-input-group>
                    <b-form-input
                        v-model="modalData.email"
                        placeholder="Email or username"
                        autofocus
                    />
                </b-input-group>
                <b-input-group>
                    <b-form-select
                        v-if="usergroups"
                        v-model="modalData.active_group"
                        @change="onActiveGroupChanged"
                    >
                        <option :value="null">
                            Select a Role
                        </option>
                        <option
                            v-for="(group, id) in usergroups"
                            :key="id"
                            :value="group"
                            @change="(value)=>{changeUserGroup(usr, usr.userGroupID, id)}"
                        >
                            {{ group.name }}
                        </option>
                    </b-form-select>
                </b-input-group>

                <div
                    v-for="error in modalData.errors"
                    :key="error.message"
                >
                    <b-alert
                        block
                        show
                        variant="warning"
                    >
                        {{ error.message }}
                    </b-alert>
                </div>

                <div slot="modal-footer">
                    <!--v-bind:ok-disabled="modalData.creating || modalData.noClose"-->
                    <b-btn 
                        :disabled="modalData.creating || modalData.noClose || !usergroups || !modalData.active_group || !checkUserManage(project.group, modalData.active_group)" 
                        variant="cliovis-blue-light" style="margin-right: 5px"
                        @click="addUser(project.pid, modalData.email, modalData.active_group.id)"
                    >
                        Add User
                    </b-btn>
                    <b-btn
                        :disabled="modalData.creating || modalData.noClose"
                        variant="secondary"
                        @click="$refs.addUserModal.hide()"
                    >
                        Cancel
                    </b-btn>
                </div>
            </b-modal>
            <b-modal
                ref="deleteUsergroupModal"
                :title="'Delete Role ' + (group_editor.active_group == null ? '' : group_editor.active_group.name) + ' from ' + project.name"
                :no-close-on-esc="modalData.noClose"
                :no-close-on-backdrop="modalData.noClose"
            >
                <div
                    v-for="error in modalData.errors"
                    :key="error.message"
                >
                    <b-alert
                        block
                        show
                        variant="warning"
                    >
                        {{ error.message }}
                    </b-alert>
                </div>

                <div slot="modal-footer">
                    <!--v-bind:ok-disabled="modalData.creating || modalData.noClose"-->
                    <b-btn
                        :disabled="modalData.creating || modalData.noClose"
                        variant="danger"
                        @click="deleteUsergroup"
                    >
                        Confirm Delete Group
                    </b-btn>
                    <b-btn
                        :disabled="modalData.creating || modalData.noClose"
                        variant="secondary"
                        @click="$refs.deleteUsergroupModal.hide()"
                    >
                        Cancel
                    </b-btn>
                </div>
            </b-modal>
            <b-modal
                ref="createUsergroupModal"
                :title="'Create Role in ' + project.name"
                :no-close-on-esc="modalData.noClose"
                :no-close-on-backdrop="modalData.noClose"
            >
                <b-input-group>
                    <b-form-input
                        v-model="modalData.name"
                        placeholder="Role Name"
                    />
                </b-input-group>

                <div
                    v-for="error in modalData.errors"
                    :key="error.message"
                >
                    <b-alert
                        block
                        show
                        variant="warning"
                    >
                        {{ error.message }}
                    </b-alert>
                </div>

                <div slot="modal-footer">
                    <!--v-bind:ok-disabled="modalData.creating || modalData.noClose"-->
                    <b-btn style="margin-right: 5px"
                        :disabled="modalData.creating || modalData.noClose"
                        variant="cliovis-blue-light"
                        @click="createUsergroup(modalData.name)"
                    >
                        Create Role
                    </b-btn>
                    <b-btn
                        :disabled="modalData.creating || modalData.noClose"
                        variant="secondary"
                        @click="$refs.createUsergroupModal.hide()"
                    >
                        Cancel
                    </b-btn>
                </div>
            </b-modal>
        </div>
        <b-modal size="wide-3" :centered="true" title="Upgrade Project - Manage Payment Plan" :hide-footer="true" ref="upgradeProjectModal" no-close-on-backdrop no-close-on-esc>
            <subscription-panel project :pid="project.id" :on-subscribe="()=>{$emit('subscribe'); getTier();}"/>
        </b-modal>
    </div>
</template>

<script>
import DueDate from './project_users/DueDate.vue';
import { mapGetters } from 'vuex';
import { Permissions } from '../models/PermissionEnum';
import { PacketType } from '@/models/Packet';
import { SendPacket } from '@/networking/SendPacket';
import SubscriptionPanel from '@/components/payment/SubscriptionPanel.vue';
import BestFitText from "@/components/BestFitText.vue";
import User from '../models/User';

export default {
    name: "ProjectUsers",
    components: {
        DueDate,
        SubscriptionPanel,
        BestFitText
    },
    props: {
        project : { type: Object, default: null }
    },
    data()
    {
        return {
            tier: null,
            dueDateEnabled: false,
            generational_key: 0,
            user_filter: "",
            users: null,
            freeUserBudget: 0,
            usergroups: null,
            usergroup_obj: null,
            group_editor: {
                active_group: null,
                selected_perms: [],
                permission_data: [
                    { name: "Access Project", perm: Permissions.ProjectAccess },
                    { name: "Edit Project Name/Description", perm: Permissions.MetadataEdit },
                    { name: "Edit Map Data", perm: Permissions.MapEdit },
                    { name: "Create Timelines (cannot edit timelines if disabled)", perm: Permissions.TimelineCreate },
                    { name: "Read All Timelines (supercedes Timeline permissions if enabled)", perm: Permissions.TimelineForceRead },
                    { name: "Share All Timelines (supercedes Timeline permissions if enabled)", perm: Permissions.TimelineForceShare },
                    { name: "Edit All Timelines (supercedes Timeline permissions if enabled)", perm: Permissions.TimelineForceWrite },
                    { name: "Moderate Project", perm: Permissions.ProjectModerate },
                    { name: "Manage Users", perm: Permissions.UserManage },
                    { name: "Invite Users", perm: Permissions.InviteManage },
                    { name: "Edit Roles", perm: Permissions.UserGroupEdit },
                    { name: "Delete Project", perm: Permissions.ProjectDelete },
                ]
            },
            modalData: {
                active_group: null,
                email: "",
                name: "",
                admin: false,
                errors: []
            }
        };
    },
    computed: {
        ...mapGetters([
            'checkUserManage',
            'checkUserGroupEdit',
        ]),
        filteredUsers()
        {
            /** @type {User[]} */
            let users =  [...this.users];
            users.sort((a, b)=>
            {
                var textA = a.uiName.toLowerCase().trim();
                var textB = b.uiName.toLowerCase().trim();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });

            let trimmed = this.user_filter.trim().toLowerCase();
            if (trimmed.length == 0)
            {
                return users;
            }
            console.log('filtering');
            users = users.filter((a)=>
            {
                // TODO: Maybe filter on username too?  Maybe not?
                return a.uiName.toLowerCase().includes(trimmed);
            });
            return users;
        },
        selected_perm_value:
        {
            get()
            {
                var x = 0;
                for (var i = 0; i < this.group_editor.selected_perms.length; ++i)
                {
                    //console.log(i + " " + this.group_editor.selected_perms[i]);
                    x = x | this.group_editor.selected_perms[i];
                }
                //console.log(x);
                return x;
            },
            set(value)
            {
                //console.log(value);
                this.group_editor.selected_perms = [];
                for (var i = 0; i < this.group_editor.permission_data.length; ++i)
                {
                    if (value & this.group_editor.permission_data[i].perm)
                    {
                        this.group_editor.selected_perms.push(this.group_editor.permission_data[i].perm);
                    }
                }
                //console.log(this.group_editor.selected_perms);
            }
        },
        freeUserCount()
        {
            let count = 0;
            if (this.users != null)
            {
                for (let i = 0; i < this.users.length; ++i)
                {
                    if (!(this.users[i].premium))
                    {
                        ++count;
                    }
                }
            }
            return count;
        },
        freeUserBudget_local()
        {
            switch (this.tier)
			{
				case 0: return 0;
				case 1: return 20;
				case 2: return 50;
				case 3: return 100;
				case 4: return 250;
			}
        }
    },
    mounted()
    {
        this.loadUserData();
        this.loadUserGroups();
        this.getTier();
    },
    methods: {
        usergroupFromID(id)
        {
            return this.usergroups.find((g)=>g.id == id);
        },
		async getTier()
		{
            this.tier = await this.$store.dispatch('getProjectSubscription', this.project.pid);
		},
        checkPermissions(perm)
        {
            return Permissions.check(this.project.group.permissions, perm);
        },
        invalidateGenerationalData()
        {
            console.log('invalidated');
            ++this.generational_key;
        },
        loadUserData()
        {
            // TODO: Refactor this
            this.$set(this, "users", null);
            this.$http.get("viewprojectusers?pid=" + this.project.pid)
                .then(
                    (resp) =>
                    {
                        const users = [];
                        for(const user of resp.data.users)
                        {
                            users.push(Object.assign(new User, user));
                        }
                        this.$set(this, "users", users);
                    },
                    (error) =>
                    {
                        console.error(error.response);
                    });
            this.loadFreeUserBudget();
        },
        loadFreeUserBudget()
        {            
            this.$http.get("projects/freeuserbudget?projectid=" + this.project.pid)
                .then(
                    (resp) =>
                    {
                        this.$set(this, "freeUserBudget", resp.data.budget);
                    },
                    (error) =>
                    {
                        console.error(error.response);
                    });
        },
        loadUserGroups(onSuccess=null)
        {
            this.$set(this, "usergroups", null);
            this.$set(this, "usergroup_obj", null);
            this.$http.get("getprojectusergroups?pid=" + this.project.id)
                .then(
                    (resp) =>
                    {
                        this.$set(this, "usergroups", resp.data.groups);
                        if (!this.usergroups)
                        {
                            console.error(`Failed to load usergroups for project ${this.project.name}`);
                            console.log(resp.data);
                            return;
                        }
                        let ugo = {};
                        for (var i = 0; i < this.usergroups.length; ++i)
                        {
                            ugo[this.usergroups[i].id] = this.usergroups[i];
                        }

                        this.$set(this, "usergroup_obj", ugo);

                        this.$set(this.project, "group", this.usergroupFromID(resp.data.group));

                        if (onSuccess != null)
                        {
                            onSuccess();
                        }
                    },
                    (error) =>
                    {
                        console.error(error.response);
                    });
        },
        clickAddUser()
        {
            this.$refs.addUserModal.show();
        },
        addUser(pid, email, role)
        {
            this.modalData.errors.length = 0;
            let data = new FormData();
            data.append("projectid", pid);
            data.append("user", email);
            data.append("access_role", role);

            this.$http.post("projects/users", data).then(
                (response)=>
                {
                    this.$refs.addUserModal.hide();
                    this.loadUserData();
			        SendPacket(PacketType.ProjectNotifyMetadataChanged, {});
                },
                (error)=>
                {
                    this.modalData.errors.push({message: error.response.data.error});
                }
            );
        },
        clickDeleteUsergroup()
        {
            this.modalData.errors.length = 0;
            this.$refs.deleteUsergroupModal.show();
        },
        deleteUsergroup()
        {
            this.modalData.errors.length = 0;

            this.$http.post("deleteusergroup?pid=" + this.project.pid + "&id=" + this.group_editor.active_group.id).then(
                (response)=>
                {
                    this.$refs.deleteUsergroupModal.hide();
                    this.loadUserGroups();
                    this.group_editor.active_group = null;
			        SendPacket(PacketType.ProjectNotifyMetadataChanged, {});
                },
                (error)=>
                {
                    this.modalData.errors.push({message: error.response.data.error});
                }
            );
        },
        clickCreateUsergroup()
        {
            this.modalData.name="";
            this.modalData.errors.length = 0;
            this.$refs.createUsergroupModal.show();
        },
        createUsergroup(name, perm = 'projectaccess')
        {
            this.modalData.errors.length = 0;

            this.$http.post("createusergroup?pid=" + this.project.pid + "&name=" + name + "&perm=" + perm).then(
                (response)=>
                {
                    this.$refs.createUsergroupModal.hide();
                    this.loadUserGroups(()=>
                    {
                        for (var i = 0; i < this.usergroups.length; ++i)
                        {
                            if (this.usergroups[i].name == name)
                            {
                                this.group_editor.active_group = this.usergroups[i];
                                this.onActiveGroupChanged();
                                break;
                            }
                        }
                    });
			        SendPacket(PacketType.ProjectNotifyMetadataChanged, {});
                },
                (error)=>
                {
                    this.modalData.errors.push({message: error.response.data.error});
                }
            );
        },
        changeUserGroup(user, oldGroup, group)
        {
            user.changingGroup = true;
            this.$http.post("changepermissions", {
                    projectid: this.project.pid,
                    userid: user.userid,
                    access_role: group
                })
                .then(
                    ()=>
                    {
                        user.userGroupID = group;
                        user.changingGroup = false;
			            SendPacket(PacketType.ProjectNotifyMetadataChanged, {});
                    },
                    (error)=>
                    {
                        user.userGroupID = oldGroup;
                        user.changingGroup = false;
                    }
                );
        },
        removeUser(usr)
        {
            let form = new FormData();
            form.append("projectid", this.project.pid);
            form.append("userid", usr.userid);

            this.$http.delete(`projects/users/id`, {data: form})
                .then(
                    (response)=>
                    {
                        this.$refs.addUserModal.hide();
                        this.loadUserData();
			            SendPacket(PacketType.ProjectNotifyMetadataChanged, {});
                    },
                    (error)=>
                    {
                        this.modalData.errors.push({message: error.response.data.error});
                    }
                );
        },
        onActiveGroupChanged()
        {
            if (this.group_editor.active_group)
            {
                this.selected_perm_value = this.group_editor.active_group.permissions;
            }
        },
        modifyUserGroupPermissions(newValue)
        {
            this.group_editor.selected_perms = newValue;
            this.group_editor.active_group.permissions = this.selected_perm_value;
            this.$http.post("modifyusergrouppermissions?pid=" + this.project.pid + "&id=" + this.group_editor.active_group.id + "&perm=" + this.selected_perm_value)
                .then(
                    (response)=>
                    {
                        SendPacket(PacketType.ProjectNotifyMetadataChanged, {});
                        // TODO: does anything else need to happen here? I don't think so.
                    },
                    (error)=>
                    {
                    // TODO: error display separate from modal?
                    //this.modalData.errors.push({message: error.response.data.error});
                    }
                );
        }
    }
};
</script>

<style scoped lang="scss">
.user_box
{
    background-color: #f8f5f4;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    padding: 2px;
    vertical-align: middle;
    overflow:   scroll;
    overflow-x: auto;
    overflow-y: auto;
    max-height: 60vh;
}

.user_entry
{
    height: 105px;
    background-color: #FFFFFF;
    border-left: 5px solid #B48E48;
    padding: 10px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
}

.userdata-container
{
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    padding: 10px;
    padding-top: 30px;
    padding-bottom: 30px;
}

.usergroup_select
{
    width: 50%;
}

.l-margin
{
    margin-left: 6px;
}
</style>
